import { websiteFlagKeys } from '@va/constants';
import { updateWebsiteFlags } from '@va/dashboard/actions/api';
import { CogIconV2 } from '@va/icons';
import { useTranslate } from '@va/localization';
import { isUserLoggedInWithCustomUrl } from '@va/standalone/shared/helpers';
import { Button, fontWeights, Heading3, IconWithBackground, Paragraph } from '@va/ui/design-system';
import { is3asApp } from '@va/util/helpers';
import { useDispatch } from 'react-redux';
import { AiChatbotView } from '../../types';
import { useAiChatbotContext } from '../aiChatbotContext';
import { AiChatbotModelSettings } from '../AiChatbotModelSettings';

export const StartScreen = () => {
  const translate = useTranslate();
  const { setSelectedView } = useAiChatbotContext();
  const dispatch = useDispatch();

  return (
    <div className='flex flex-col p-4u flex-1'>
      <div className='flex-1 flex flex-col justify-center items-center text-center'>
        <IconWithBackground className='bg-white-84 mb-10u' icon={() => <CogIconV2 color={'var(--color-primary)'} />} />
        <Heading3 weight={fontWeights.semibold} variant='display' variantSize='regular' className='mb-4u'>
          {translate('aiChatbot.startScreen.title')}
        </Heading3>
        <Paragraph
          weight={fontWeights.medium}
          variant='interface'
          variantSize='large'
          className='mb-10u'
          colorClassName='text-gray-tundora'
        >
          {translate('aiChatbot.startScreen.description')}
        </Paragraph>
        <AiChatbotModelSettings />
        <Paragraph
          weight={fontWeights.medium}
          variant='interface'
          variantSize='regular'
          className='mt-3u'
          colorClassName='text-gray-tundora'
        >
          {translate('aiChatbot.startScreen.modelSettingsHint')}
        </Paragraph>
      </div>

      <div>
        <Paragraph
          weight={fontWeights.medium}
          variant='interface'
          variantSize='regular'
          className='mb-4u text-center'
          colorClassName='text-gray-tundora'
        >
          {translate('aiChatbot.startScreen.acceptAddendum')}{' '}
          <a
            className='underline text-primary'
            href={
              is3asApp() || isUserLoggedInWithCustomUrl()
                ? translate('aiChatbot.startScreen.addendumWhitelabeledLink')
                : translate('aiChatbot.startScreen.addendumLink')
            }
            target={'_blank'}
            rel='noreferrer'
          >
            {translate('aiChatbot.startScreen.addendumLabel')}
          </a>
        </Paragraph>
        <Button
          onClick={() => {
            setSelectedView(AiChatbotView.NewChat);
            dispatch(updateWebsiteFlags({ [websiteFlagKeys.AI_ONBOARDING_COMPLETED]: true }, true));
          }}
          size='small'
          textClasses='text-interface-regular leading-interface-regular'
          className='w-full h-24u'
          text={translate('aiChatbot.startScreen.startButton')}
        />
      </div>
    </div>
  );
};
